import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  modalContainer: {
    minWidth: theme.spacing(100),
  },
  actionOffsets: {
    padding: theme.spacing(1, 3, 2),
  },
}));

export default useStyles;
